import { useSelector } from 'react-redux'
import { getContractorPortalAuthToken, getAuthToken } from 'src/selectors/auth'

export const useAuthTokens = () => {
  const authToken = useSelector(getAuthToken)
  const contractorPortalAuthToken = useSelector(getContractorPortalAuthToken)

  return {
    authToken,
    contractorPortalAuthToken,
  }
}
